module.exports = __webpack_public_path__ + "/images/shop/icon/pbl_p.svg";